export default __webpack_public_path__ + "static/media/spark_84.bc336de6.png";